import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Card, Section } from './Card';

export const Stories = ({ isVisible }) => (
  <Section
    id="stories"
    isVisible={isVisible}
    title={<>Client <span style={{ color: COLORS.cantaloupe }}>Stories</span></>}
    subtitle={siteContent.caseStudies.subtitle}
  >
    <div className="space-y-8">
      {siteContent.caseStudies.stories.map((study) => (
        <Card key={study.title}>
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-3" style={{ color: COLORS.navy }}>{study.title}</h3>
              <div className="text-sm mb-2" style={{ color: COLORS.slate }}>Challenge:</div>
              <p style={{ color: COLORS.slate }}>{study.challenge}</p>
            </div>
            <div>
              <div className="text-sm mb-2" style={{ color: COLORS.slate }}>Strategy:</div>
              <p style={{ color: COLORS.slate }}>{study.strategy}</p>
            </div>
            <div>
              <div className="text-sm mb-2" style={{ color: COLORS.slate }}>Outcome:</div>
              <p className="font-semibold" style={{ color: COLORS.cantaloupe }}>{study.outcome}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  </Section>
);
